export function formatPair(symbol: string | undefined | null): string {
  const s = String(symbol || '').trim().toUpperCase()
  if (!s) return '-'
  const m = s.match(/^(.*?)(USDT|USDC|BTC)$/)
  if (m) return `${m[1]}/${m[2]}`
  const clean = s.replace(/[^A-Z0-9]/g, '')
  const m2 = clean.match(/^(.*?)(USDT|USDC|BTC)$/)
  if (m2) return `${m2[1]}/${m2[2]}`
  return s
}

